// The veil: the Monad rising at the end of a rite, and the moves and par in
// the table's own numerals.

import { MOTION } from "../config/motion.ts"
import { RULES } from "../config/rules.ts"
import { WORDS } from "../config/words.ts"
import { html } from "../boundary/html.ts"
import type { Clock } from "../effects/clock.ts"
import { setHtml } from "./dom.ts"
import { sigil } from "./glyph.ts"
import { numeral } from "./lattice.ts"

export type Result = {
  readonly moves: number
  readonly par: number
  readonly pure: boolean
}

export const celebrate = (veil: HTMLElement, clock: Clock, r: Result): Promise<void> =>
  new Promise((resolve) => {
    const digits = RULES.counterDigits
    setHtml(
      veil,
      html`
      <div class="monad-rise">${sigil(["folded", "folded", "folded"])}</div>
      <div class="win-stats">
        <div class="win-row"><span class="win-label">${WORDS.veil.moves}</span>${numeral(r.moves, digits)}</div>
        <div class="win-row"><span class="win-label">${WORDS.veil.par}</span>${numeral(r.par, digits)}</div>
        ${r.pure ? html`<div class="win-pure">${WORDS.veil.unaided}</div>` : html``}
      </div>
      <button class="win-go" type="button" aria-label="${WORDS.veil.back}"><span></span></button>`,
    )
    veil.hidden = false
    veil.classList.remove("show")
    void veil.offsetWidth
    veil.classList.add("show")
    const done = (): void => {
      veil.hidden = true
      veil.classList.remove("show")
      veil.removeEventListener("click", done)
      resolve()
    }
    clock.after(MOTION.ms.veilWait, () => veil.addEventListener("click", done))
  })
